import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Will as SectionKey } from 'Consts/Questionnaire';
import CircleWithCount from 'Icons/CircleWithCount';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import Section from '../Section';
import FieldList from '../Fields/FieldList';
import TextInput from '../Fields/TextInput';
import DateInput from '../Fields/DateInput';
import USStateInput from '../Fields/USStateInput';

class WillForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
    };
    this.handleTitleChange = this.handleTitleChange.bind(this);
  }

  handleTitleChange(key, val) {
    if (val === null) {
      return;
    }
    const months = [
      '',
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const dateParts = val.split('-');
    if (dateParts.length < 3) {
      return;
    }
    const year = dateParts[0];
    const month = parseInt(dateParts[1], 10);
    if (
      Number.isNaN(month)
      || month < 1
      || month > 12
      || !year.match(/[0-9]{4}/)
    ) {
      return;
    }
    this.setState({ title: `Will - ${months[month]} ${year}` });
  }

  render() {
    const { title } = this.state;
    const {
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.25}
        title={title || 'New will'}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <DateInput
          name={`willDateExecuted.${id}`}
          answerKey="willDateExecuted"
          placeholder="Date executed"
          onChange={this.handleTitleChange}
        />
        <USStateInput
          name={`willStateExecuted.${id}`}
          answerKey="willStateExecuted"
          label="State in which executed:"
          value=""
        />
        <TextInput
          name={`willPersonalRepresentative.${id}`}
          answerKey="willPersonalRepresentative"
          placeholder="Personal representative"
        />
        <TextInput
          name={`willGuardian.${id}`}
          answerKey="willGuardian"
          placeholder="Guardian (if children under age of majority)"
        />
        <TextInput
          name={`willTrustee.${id}`}
          answerKey="willTrustee"
          placeholder="Trustee(s) (if testamentary trusts)"
        />
        <TextInput
          name={`willTestator.${id}`}
          answerKey="willTestator"
          placeholder="Testator"
        />
      </LabeledVerticalExpander>
    );
  }
}

WillForm.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.any.isRequired,
  expanded: PropTypes.bool,
};

WillForm.defaultProps = {
  expanded: false,
};

const WillSection = () => {
  const [count, setCount] = React.useState(0);

  return (
    <Section transitionSpeed={0.25} title="Will" expanded={QueryVal(section) === SectionKey} sectionKey={SectionKey} CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}>
      <FieldList
        onCountUpdate={setCount}
        label="Wills"
        addLabel="Add a will"
        keyPrefix="will"
        Of={WillForm}
      />
    </Section>
  );
};

export default WillSection;
